/**
 *  @class
 *  @function SocialShare
 */
if (!customElements.get('social-share')) {
  class SocialShare extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.links = this.querySelectorAll('a.social:not(.clipboard):not(.whatsapp)');
      this.instagramButton = this.querySelector('[data-instagram-share]');

      this.setupEventListeners();
    }

    setupEventListeners() {
      this.links.forEach((link) => {
        link.addEventListener('click', (event) => {
          let left = (screen.width / 2) - (640 / 2),
            top = (screen.height / 2) - (440 / 2) - 100;
          window.open(link.getAttribute('href'), 'mywin', 'left=' + left + ',top=' + top + ',width=640,height=440,toolbar=0');
          event.preventDefault();
        });
      });
      if (this.instagramButton) {
        this.instagramButton.addEventListener('click', async (event) => {
          event.preventDefault();
          const button = this.instagramButton;
          const url = button.dataset.shareUrl;
          const title = button.dataset.shareTitle || document.title;

          if (navigator.share) {
            try {
              await navigator.share({ title, url });
            } catch (error) {
              if (error.name !== 'AbortError') {
                this.copyLinkForInstagram(button, url);
              }
            }
            return;
          }

          this.copyLinkForInstagram(button, url);
        });
      }
    }

    async copyLinkForInstagram(button, url) {
      try {
        await navigator.clipboard.writeText(url);
        const feedback = button.querySelector('[data-share-feedback]');
        if (feedback) feedback.textContent = 'Link copied. Paste it into Instagram to share.';
        button.classList.add('clipboard-success');
        window.setTimeout(() => {
          button.classList.remove('clipboard-success');
          if (feedback) feedback.textContent = '';
        }, 3000);
      } catch (error) {
        window.prompt('Copy this product link to share on Instagram:', url);
      }
    }
  }
  customElements.define('social-share', SocialShare);
}